// kvの波紋エフェクト
(() => {
  const $rippleContainer = $('.ripple__animation');
  if ($rippleContainer.length === 0) {
    return;
  }
  const width = $rippleContainer.outerWidth();
  const height = $rippleContainer.outerHeight();
  $rippleContainer.ripples({ interactive: false });

  // 波紋の設定
	const x = width / 2; // 画面中央
	const y = height / 5; // 少し上寄り
  const strength = 0.7; // 波紋の強さ
  const dropRadius = 40; // 波紋の半径
  $rippleContainer.ripples('drop', x, y, dropRadius, strength);

  // 2秒後にフェードアウト＆破棄
  setTimeout(() => {
    $rippleContainer.css({
      'transition': 'opacity 0.4s ease-out',
      'opacity': '0'
    });
    setTimeout(() => {
      $rippleContainer.ripples('destroy');
    }, 400);
  }, 400);
})();


window.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    document.querySelectorAll('.ripple__animation, .ripple__background').forEach(el => {
      el.style.transition = 'opacity 0.4s ease-out';
      el.style.opacity = '0';
    });
  }, 400);
});
